import { apiBaseUrl } from "./api";
import { CANONICAL_API_ORIGIN } from "./apiBase";

/** Resolve blog media URL — always on the API host (not paisacx.io origin). */
export function blogMediaUrl(path) {
  if (!path) return "";
  const mediaPath = path.match(/(\/api\/cms\/blog\/media\/[^?#]+)/i);
  const rel = mediaPath ? mediaPath[1] : path.startsWith("/") ? path : `/${path}`;

  if (/^https?:\/\//i.test(path) && mediaPath) {
    const base = apiBaseUrl() || CANONICAL_API_ORIGIN;
    return `${base.replace(/\/$/, "")}${rel}`;
  }
  if (/^https?:\/\//i.test(path)) return path;

  const base =
    apiBaseUrl() ||
    (typeof window !== "undefined" ? window.location.origin : CANONICAL_API_ORIGIN);
  return `${base.replace(/\/$/, "")}${rel}`;
}
